import React, { useState } from "react";
import allApi from "../../../api/allApi";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useLocalization } from "../localization/LocalizationContext";
import eyeIcon from "../../../assets/images/eye-open.svg";
import eyeCloseIcon from "../../../assets/images/eye-close.svg";
function CreatetemplatePopup({
  showPopUp,
  handleClose,
  headerMessage1,
  handleSuccess,
  onTemplateAdd,
}) {
  const initialFormValues = {
    template_name: "",
    snmp_port: 161,
    retry_count: 3,
    timeout: "",
    version: "",
    read_only_community: "",
    readwrite_community: "",
    trap_community: "HFcltD#123!@",
    trap_host: "",
    trap_port: 162,
    trap_host_version: "",
    username: "",
    security_level: "",
    authentication_password: "",
    encryption: "",
    access_privilege: "",
    privacy_key: "",
    status: "Active",
    dcdr_config: "incx_dcdr",
    dcdr_interval: 300,
    dcdr_retry_count: 5,
    dcdr_rev_retry_count: 5,
    dcdr_switch_rev_interval: 300,
    dcdr_rev_time: 30,
  };
  const { localizationStrings } = useLocalization();
  const [formValues, setFormValues] = useState(initialFormValues);
  const [missingFields, setMissingFields] = useState([]);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [error, setError] = useState(null);
  const [version, setVersion] = useState("");
  const [trapVersion, setTrapVersion] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [snmpTemplates, setSnmpTemplates] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    if (
      ["snmp_port", "timeout", "trap_port", "retry_count"].includes(name) &&
      !/^\d+$/.test(value)
    ) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `${name.replace(/_/g, " ")} must be a numeric value.`,
      }));
    } else if (name === "snmp_port" && !/^[a-zA-Z0-9_.-]*$/.test(value)) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Trap host must be alphanumeric.",
      }));
    } else if (name === "trap_port" && !/^\w+$/.test(value)) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `${name.replace(/_/g, " ")} must be alphanumeric.`,
      }));
    } else if (name === "retry_count" && !/^\w+$/.test(value)) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `${name.replace(/_/g, " ")} must be alphanumeric.`,
      }));
    } else {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  const handleTrapVersionChange = (e) => {
    setTrapVersion(e.target.value);
    setFormValues((prevValues) => ({
      ...prevValues,
      trap_host_version: e.target.value,
    }));
  };

  const handleVersionChange = (e) => {
    setVersion(e.target.value);
    setFormValues((prevValues) => ({
      ...prevValues,
      version: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    const hasErrors = Object.values(validationErrors).some(
      (error) => error !== undefined
    );
    if (hasErrors) {
      return;
    }
    let payload = {
      template_name: formValues.template_name,
      snmp_port: formValues.snmp_port,
      retry_count: formValues.retry_count,
      timeout: formValues.timeout,
      version: formValues.version,
      read_only_community: formValues.read_only_community,
      readwrite_community: formValues.readwrite_community,
      trap_community: formValues.trap_community,
      trap_host: formValues.trap_host,
      trap_port: formValues.trap_port,
      trap_host_version: formValues.trap_host_version,
      status: formValues.status,
      dcdr_config: "incx_dcdr",
      dcdr_interval: 300,
      dcdr_retry_count: 5,
      dcdr_rev_retry_count: 5,
      dcdr_switch_rev_interval: 300,
      dcdr_rev_time: 30,
    };

    if (formValues.trap_host_version === "v3") {
      payload = {
        ...payload,
        username: formValues.username,
        security_level: formValues.security_level,
        authentication_password: formValues.authentication_password,
        encryption: formValues.encryption,
        access_privilege: formValues.access_privilege,
        privacy_key: formValues.privacy_key,
      };
    }

    try {
      const api = new allApi();
      const response = await api.postRequest(
        `api/snmp/template/add`,
        "",
        payload
      );
      if (response.status === "201") {
        handleClose();
        setShowSuccessModal(true);
        handleSuccess();
        onTemplateAdd(response.data);
        resetForm();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const disableAdd =
    trapVersion === "v3"
      ? !(
        formValues.template_name &&
        formValues.snmp_port &&
        formValues.retry_count &&
        formValues.timeout &&
        formValues.version &&
        formValues.read_only_community &&
        formValues.readwrite_community &&
        formValues.trap_community &&
        formValues.trap_host &&
        formValues.trap_port &&
        formValues.trap_host_version &&
        formValues.username &&
        formValues.security_level &&
        formValues.authentication_password &&
        formValues.encryption &&
        formValues.access_privilege &&
        formValues.privacy_key
      )
      : !(
        formValues.template_name &&
        formValues.snmp_port &&
        formValues.retry_count &&
        formValues.timeout &&
        formValues.version &&
        formValues.read_only_community &&
        formValues.readwrite_community &&
        formValues.trap_community &&
        formValues.trap_host &&
        formValues.trap_port &&
        formValues.trap_host_version
      );

  const resetForm = () => {
    setFormValues(initialFormValues);
    setValidationErrors({});
    setVersion("");
    setTrapVersion("");
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    handleClose();
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <>
      {showPopUp && (
        <div
          className={"modal fade customModal " + (showPopUp ? " show" : "")}
          id="discover"
          style={{ display: showPopUp ? "block" : "none", zIndex: 1009 }}
        >
          <div className="modal-dialog modal-dialog-centered create-usr-pop">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {headerMessage1}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    resetForm();
                    handleClose();
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <div className="tab-content">
                  <div className="tab-pane fade show active">
                    <form>
                      {/* Row 1 */}
                      <div className="row">
                        <div className="col-lg-6">
                          <label className="col-form-label">
                            {localizationStrings?.templateName}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="template_name"
                            value={formValues.template_name}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="col-form-label">
                            {localizationStrings?.snmpPort}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control readonly-field"
                            name="snmp_port"
                            value={formValues.snmp_port}
                            readOnly
                          />
                          {validationErrors.snmp_port && (
                            <div className="text-danger">{validationErrors.snmp_port}</div>
                          )}
                        </div>
                      </div>

                      {/* Row 2 */}
                      <div className="row">
                        <div className="col-lg-6">
                          <label className="col-form-label">
                            {localizationStrings?.retryCount}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control readonly-field"
                            name="retry_count"
                            value={formValues.retry_count}
                            readOnly
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="col-form-label">
                            {localizationStrings?.timeout}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="timeout"
                            value={formValues.timeout}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      {/* Row 3 */}
                      <div className="row">
                        <div className="col-lg-6">
                          <label className="col-form-label">
                            {localizationStrings?.trapHostVersion}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={formValues.trap_host_version}
                            onChange={handleTrapVersionChange}
                          >
                            <option value="">{localizationStrings?.selectVersion}</option>
                            <option value="IPv4">IPv4</option>
                            <option value="IPv6">IPv6</option>
                          </select>
                        </div>

                        <div className="col-lg-6">
                          <label className="col-form-label">
                            {localizationStrings?.readOnlyCommunity}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="read_only_community"
                            value={formValues.read_only_community}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      {/* Row 4 */}
                      <div className="row">
                        <div className="col-lg-6">
                          <label className="col-form-label">
                            {localizationStrings?.readWriteCommunity}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="readwrite_community"
                            value={formValues.readwrite_community}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="col-form-label">
                            {localizationStrings?.trapCommunity}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control readonly-field"
                            name="trap_community"
                            value={formValues.trap_community}
                            readOnly
                          />
                        </div>
                      </div>

                      {/* Row 5 */}
                      <div className="row">
                        <div className="col-lg-6">
                          <label className="col-form-label">
                            {localizationStrings?.trapHost}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="trap_host"
                            value={formValues.trap_host}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="col-form-label">
                            {localizationStrings?.trapPort}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control readonly-field"
                            name="trap_port"
                            value={formValues.trap_port}
                            readOnly
                          />
                        </div>
                      </div>

                      {/* Version + Username */}
                      <div className="row">
                        <div className="col-lg-6">
                          <label className="col-form-label">
                            {localizationStrings?.version}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={version}
                            onChange={handleVersionChange}
                          >
                            <option value="">{localizationStrings?.selectVersion}</option>
                            <option value="v1">v1</option>
                            <option value="v2c">v2c</option>
                            <option value="v3">v3</option>
                          </select>
                        </div>

                        {version === "v3" && (
                          <div className="col-lg-6">
                            <label className="col-form-label">
                              {localizationStrings?.username}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="username"
                              value={formValues.username}
                              onChange={handleInputChange}
                            />
                          </div>
                        )}
                      </div>

                      {version === "v3" && (
                        <>
                          <div className="row">
                            <div className="col-lg-6">
                              <label className="col-form-label">
                                {localizationStrings?.securityLevel}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="security_level"
                                value={formValues.security_level}
                                onChange={handleInputChange}
                              />
                            </div>

                            <div className="col-lg-6">
                              <label className="col-form-label">
                                {localizationStrings?.authenticationMethod}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="auth_method"
                                value={formValues.auth_method}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-6 position-relative">
                              <label className="col-form-label">
                                {localizationStrings?.authenticationPassword}
                                <span className="text-danger">*</span>
                              </label>                              
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                name="authentication_password"
                                value={formValues.authentication_password}
                                onChange={handleInputChange}
                              />
                              <img
                                src={showPassword ? eyeIcon : eyeCloseIcon}
                                alt="toggle"
                                className="show-password"
                                style={{top: '42px'}}
                                onClick={togglePasswordVisibility}
                              />
                            </div>

                            <div className="col-lg-6">
                              <label className="col-form-label">
                                {localizationStrings?.encryption}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="encryption"
                                value={formValues.encryption}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-6">
                              <label className="col-form-label">
                                {localizationStrings?.privacyKey}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="privacy_key"
                                value={formValues.privacy_key}
                                onChange={handleInputChange}
                              />
                            </div>

                            <div className="col-lg-6">
                              <label className="col-form-label">
                                {localizationStrings?.accessPrivilege}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="access_privilege"
                                value={formValues.access_privilege}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </form>
                    <div className="modal-footer pb-0">
                      <button
                        type="button"
                        className="btn btn-outline"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                          resetForm();
                          handleClose();
                        }}
                      >
                        {localizationStrings?.cancel}
                      </button>
                      <button
                        type="button"
                        className={`text-btn primary-btn`}
                        disabled={disableAdd}
                        onClick={() => {
                          handleSubmit();
                        }}
                        aria-label="Close"
                      >
                        {localizationStrings?.add}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        show={showSuccessModal}
        onHide={handleSuccessModalClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.templateCreatedSuccessfully}!</p>
        <Button onClick={() => {
          handleSuccessModalClose();
          onTemplateAdd();
        }}>
          {localizationStrings?.ok}
        </Button>
      </Modal>
    </>
  );
}

export default CreatetemplatePopup;
